<template>

    <div class="user">
    
  
      
        <div style="width: 100%;border: 1px solid #f7f7f7;float: left;height: 550px;overflow-y: auto;padding: 10px; ">
          <el-form :inline="true" size="small"  class="demo-form-inline">
         
            <el-form-item >
              <el-input style="width: 45%;float: left;" placeholder="请输入仓库名称" v-model="search">
            
             </el-input>
              <el-button  style="width: 25%;float: left;margin-left: 2%;" type="primary" icon="el-icon" @click="getWarehouse">查询</el-button>
              <el-button  style="width: 25%;float: left;margin-left: 2%;background: #999;border: 1px solid #999;" type="primary" icon="el-icon" @click="reast">重置</el-button>
              <div style="clear: both;"></div>
            </el-form-item>
  
        </el-form>  
          
          
        <el-table
        
              :data="WarehouseList"
              highlight-current-row
              @current-change="handleCurrentChange"
              border
              style="width: 100%"
              row-key="warehouse_id"
              >
              <!-- <el-table-column prop="supply_name" label="供应商" > </el-table-column> -->
              <el-table-column prop="name" label="仓库名称" > </el-table-column>
              <el-table-column prop="warehouse_kw_id" label="ID" > </el-table-column>
              <el-table-column prop="numb" label="编号" > </el-table-column>
            
          
            </el-table>
    </div>
      
    

    
    </div>
  </template>
  
  <script>

    import WarehouseApi from '@/api/warehouse.js';
 
    export default {

      inject: ['reload'],
      data() {
        return {
        
  
  
          search:"",
          WarehouseList:[],
          currentRow :null
        };
      },
      created() {
        this.getWarehouse();
 
      },
      props:['choose_supply_id'],
      methods: {

        handleCurrentChange(val) {
    
            this.currentRow = val;
 
           let self = this;
   
           this.$emit("handleCurrentChange", { openDialog: false,
            "warehouse_id":val.warehouse_id,
            "warehouse_kw_id":val.warehouse_kw_id
            });
      },
      reast() {
    
                this.currentRow = null;
                this.$emit("reast", { openDialog: false,"id":0 });
            },
        getWarehouse() {
            let self = this;
            self.loading = true
            let Params = {}
            Params.page = 1
            Params.list_rows = 9000
            Params.search = self.search
            Params.choose_supply_id = self.choose_supply_id;
            WarehouseApi.list(Params, true)
              .then(data => {
                self.loading = false
                self.WarehouseList = data.data.list.data
   
              })
              .catch(error => {
                self.loading = false
              });
      },
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/components/select/warehouse.vue